import router from '@/router';
import BroadcastBuider from '@/services/broadcast-builder.service';
import api from '@/api';

const state = {
  BroadcastBuider: new BroadcastBuider()
};

const getters = {};

const actions = {
  startBroadcast({ state, commit, dispatch }, url) {
    const body = state.BroadcastBuider.createStartBroadcastRequest({
      broadcastType: 1,
      broadcastUrl: url
    });
    return new Promise(resolve => {
      api.startBroadcast(body).then(response => {
        router.push({
          name: 'BroadcastingTab',
          params: {rstp: encodeURI(url)}
        });
        resolve();
      });
    });
  },

  stopBroadcast({ state, commit, dispatch }) {
    api.stopBroadcast().then(response => {
      router.push({
        name: 'MainMenu'
      });
    });
  },

  checkBroadcastingStatus({ state, commit, dispatch }) {
    api.checkBroadcastingStatus().then(response => {
      router.push({
        name: 'BroadcastingTab'
      });
    }, () => {
      console.info('Broadcasting was not started');
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/broadcast/broadcast.js